import { Injectable } from '@angular/core';

export type GalleryAnalyticsEvent =
  | 'gallery_open'
  | 'slide_view'
  | 'fullscreen_enter'
  | 'fullscreen_exit';

export interface GalleryAnalyticsPayload {
  galleryLayout?: string;
  slideIndex?: number;
  slideCount?: number;
  source?: string;
}

@Injectable({ providedIn: 'root' })
export class GalleryAnalyticsService {
  track(event: GalleryAnalyticsEvent, payload: GalleryAnalyticsPayload = {}): void {
    const detail = { event, ...payload, timestamp: Date.now() };
    window.dispatchEvent(new CustomEvent('azone-gallery', { detail }));

    const dataLayer = (window as Window & { dataLayer?: unknown[] }).dataLayer;
    if (Array.isArray(dataLayer)) {
      dataLayer.push(detail);
    }
  }
}
